import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse, ProperHttpParamEncoder } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TaskSummaryModel } from 'app/generated/backend/task/api/task-summary-model';

@Injectable()
export class TaskSummaryHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		partyId: number
	): Observable<JsonResourceResponse<TaskSummaryModel[]>> {
		let params = new HttpParams({ encoder: new ProperHttpParamEncoder() });
		if (partyId!==null && partyId!==undefined) {
			params = params.set('partyId', partyId.toString());
		}
		return this.http.get<JsonResourceResponse<TaskSummaryModel[]>>('api/v1/task/summary', { params }).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		TaskSummaryHandlerService
	]
})
export class TaskSummaryHandlerModule { }
